<ng-container *ngIf="status$ | async as status">
    <ng-container *ngIf="status === 'idle'; else loading">
        <ng-container *ngIf="products$ | async as products">
            <ng-container *ngIf="products.length else emptyState">
                <ng-container *ngFor="let grid of products | ArrayChunking : gridType; trackBy: trackFn; let last = last">
                    <app-product-grid-blueprint
                        [gridVersion]="grid.type"
                        [gridHits]="grid.hits"
                        [isLast]="last"
                    ></app-product-grid-blueprint>
                </ng-container>
            </ng-container>

            <app-selection-footer *ngIf="productSelectionService.isInSelectMode$ | async"
                                  [selectedProductsCount]="productSelectionService.EANCodes.size"
                                  [maxSelectedProductsCount]="maxSelectedProductsCount"
                                  (selectAll)="selectAllProducts()"
                                  (deselectAll)="productSelectionService.deselectAllProducts()"
                                  (closeFooter)="productSelectionService.closeFooter()"
            >
                <div class="control-container">
                    <div class="custom-select-container">
                        <app-select [control]="productSelectionService.selectedAction">
                            <option value="" disabled selected hidden class="placeholder">{{ 'common.choose-action' | translate }}</option>
                            <option value="add-cart">{{ 'products.add-to-cart' | translate }}</option>
                            <option value="add-wishlist">{{ 'products.add-to-wishlist' | translate }}</option>
                            <option value="select-download">{{'assortment.choose-files-download' | translate}}</option>
                            <option value="add-assortment">{{ 'products.add-to-assortment' | translate }}</option>
                        </app-select>
                    </div>

                    <app-button (click)="productSelectionService.handleSelectionAction()"
                                [disabled]="! productSelectionService.selectedAction.value"
                                [state]="productSelectionService.handleInProgress ? 'loading' : 'idle'"
                                size="smaller"
                    >
                        {{ 'common.apply' | translate }}
                    </app-button>
                </div>
            </app-selection-footer>

            <ng-template #emptyState>
                <div class="empty-state">
                    <app-empty-state [emptyState]="emptyStateObject"></app-empty-state>
                </div>
            </ng-template>
        </ng-container>
    </ng-container>
</ng-container>

<ng-template #loading>
    <app-page-spinner></app-page-spinner>
</ng-template>
